<div class="modal-background" *ngIf="isOpen">
	<div class="confirmation-modal">
		<div class="title zk-mb-5">
			{{ 'PROMPTUARY.MODAL.MEMED.TITLE' | translate }}
		</div>
		<div
			class="info zk-mb-5"
			[innerHTML]="'PROMPTUARY.MODAL.MEMED.DESCRIPTION' | translate"
		></div>
		<div
			class="info zk-mb-5"
			[innerHTML]="'PROMPTUARY.MODAL.MEMED.DESCRIPTION_2' | translate"
		></div>
		<div class="buttons-footer">
			<freud-button (click)="createMemedAccount()">
				{{ 'PROMPTUARY.MODAL.MEMED.CONFIRM' | translate }}
			</freud-button>
			<freud-button color="secondary" (click)="close.emit()">
				{{ 'PROMPTUARY.MODAL.MEMED.CLOSE' | translate }}
			</freud-button>
		</div>
	</div>
</div>
